import React, { useEffect, useRef, useState } from 'react';

// Module-level flag to prevent duplicate rendering across component instances and React StrictMode
let widgetMounted = false;

const DialogflowWidget: React.FC = () => {
  const [shouldRender, setShouldRender] = useState(false);
  const mountedRef = useRef(false);

  useEffect(() => {
    // Prevent duplicate mounting even in React StrictMode
    if (mountedRef.current || widgetMounted) {
      return;
    }

    // Check if element with id="Ai" already exists in DOM
    if (document.getElementById('Ai')) {
      return;
    }

    mountedRef.current = true;
    widgetMounted = true;
    setShouldRender(true);
  }, []);

  // Don't render if element already exists or not ready
  if (!shouldRender || document.getElementById('Ai')) {
    return null;
  }

  return (
    <div id="Ai">
      <df-messenger
        id="chatbot"
        project-id="keren-kayemet-prod"
        agent-id="7bd5c247-ad23-46a6-856d-457b679af276"
        language-code="he-il"
        allow-feedback="all"
        intent="welcome_message"
        max-query-length="-1"
      >
        <df-messenger-chat-bubble
          chat-title="שואלים את תמרה"
          chat-title-icon="SVTemplate/img/png/KKL_logoAi.png"
          placeholder-text="במה אפשר לעזור?"
          chat-icon="SVTemplate/img/svg/aiNewDesktop.svg"
          anchor="top-right"
          bot-writing-image="https://assets.interface.ai/widget/loading_dots.gif"
          bot-actor-image="SVTemplate/img/png/KKL_logoAi.png"
        ></df-messenger-chat-bubble>
      </df-messenger>
    </div>
  );
};

export default DialogflowWidget;

